import React, { useState, useEffect } from 'react';

const ProductImage = ({ src, alt, category, productName, className }) => {
  const [imageSrc, setImageSrc] = useState(src);
  const [error, setError] = useState(false);
  const formats = ['jpg', 'jpeg', 'png', 'webp'];

  useEffect(() => {
    setImageSrc(src);
    setError(false);
  }, [src]);

  const tryNextFormat = (currentSrc) => {
    // Если текущий путь уже содержит формат, пробуем следующий
    const basePath = currentSrc.replace(/\.(jpg|jpeg|png|webp)$/i, '');
    const currentFormat = currentSrc.match(/\.(jpg|jpeg|png|webp)$/i)?.[1]?.toLowerCase();
    
    if (currentFormat) {
      const currentIndex = formats.findIndex(f => f === currentFormat || (f === 'jpg' && currentFormat === 'jpeg'));
      if (currentIndex < formats.length - 1) {
        const nextFormat = formats[currentIndex + 1];
        return `${basePath}.${nextFormat}`;
      }
    }
    
    // Если это был последний формат, пробуем первый с другим базовым именем
    if (category && productName) {
      // Извлекаем ключевое слово из названия товара
      const keyword = productName
        .replace(/^(Chaser\s+Black\s+6%\s*\(?|ELFLIQ\s+5%\s+30ml\s*\(?|RAYA\s+D3\s+25000\s*\(?)/i, '')
        .replace(/\)$/, '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[()]/g, '')
        .replace(/%/g, 'percent');
      
      const words = keyword.split('-');
      if (words.length > 1) {
        // Пробуем только первое слово
        return `/images/${category}/${words[0]}.${formats[0]}`;
      }
    }
    
    return null;
  };

  const handleError = () => {
    const nextSrc = tryNextFormat(imageSrc);
    if (nextSrc && nextSrc !== imageSrc) {
      setImageSrc(nextSrc);
    } else {
      setError(true);
    }
  };

  if (error) {
    return null;
  }

  return (
    <img 
      src={imageSrc} 
      alt={alt}
      className={className}
      loading="lazy"
      onError={handleError}
    />
  );
};

export default ProductImage;

